import styled from 'styled-components/macro';

export const Component = styled.header`
    width: 100%;
    height: calc(var(--header-sz-height) + var(--support-sz-height));
    padding: 0 20px;
    display: flex;
    flex-flow: column nowrap;
    background: var(--page-bg-primary);
    color: var(--text-color-primary);
    z-index: 4;
`;

export const MainContent = styled.div`
    height: var(--header-sz-height);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const SupportContacts = styled.div`
    height: var(--support-sz-height);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: var(--text-sz-note);
    
    a {
        text-decoration: none;
        color: var(--brand-color-1);
    }
`;

export const Logo = styled.div`
    height: var(--header-sz-height);
    cursor: pointer;
    
    a {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        text-decoration: none;
    }
`;

export const Nav = styled.nav`
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    
    h1 {
        color: var(--brand-color-1);
        font-size: var(--text-sz-base);
        font-family: var(--font-bold), sans-serif;
        text-transform: uppercase;
    }
`;

export const Menu = styled.div<{ isActiveMenu:boolean }>`
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    position: relative;
    
    button {
        height: 32px;
        padding: 8px;
        position: absolute;
        right: -8px;
        background: none;
        border: none;
        cursor: pointer;
        
        svg {
            width: var(--icon-sz-width);
            height: var(--icon-sz-height);

            path {
                fill: ${({ isActiveMenu }) => (isActiveMenu ? 'var(--brand-color-1)' : 'var(--text-color-secondary)')};
            }
        }
    }
    
    span {
        position: absolute;
        right: 30px;
        line-height: var(--text-sz-hint);
        font-size: var(--text-sz-hint);
    }
`;
